import { openapi } from "../../openapi";

// Keep every scope list and detail query in the affected project up to date.
export const viewPresetsApiEnhancer = openapi.enhanceEndpoints({
  addTagTypes: ["ViewPresets"],
  endpoints: {
    getMultiplacerViews: {
      providesTags: (_result, _error, args) => [{ type: "ViewPresets", id: args.projectNo }],
    },
    getMultiplacerViewsByViewId: {
      providesTags: (_result, _error, args) => [{ type: "ViewPresets", id: args.projectNo }],
    },
    postMultiplacerViews: {
      invalidatesTags: (_result, error, args) => error || args.body.data.kind !== "preset" ? [] : [{ type: "ViewPresets", id: args.body.projectNo }],
    },
    patchMultiplacerViewsByViewId: {
      invalidatesTags: (_result, error, args) => error ? [] : [{ type: "ViewPresets", id: args.body.projectNo }],
    },
    deleteMultiplacerViewsByViewId: {
      invalidatesTags: (_result, error, args) => error ? [] : [{ type: "ViewPresets", id: args.projectNo }],
    },
  },
});
